export default () => ({
  trigger: {
    name: 'search.focus',
    params: {},
  },
  config: {
    event: {
      name: 'select_input_field',
      params: {
        sub_feature: 'header',
        input_field: null,
        status: 'focus',
        content: null,
      },
    },
  },
});
